var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"size":"xl","title":"Image Preview","centered":"","hide-footer":""},model:{value:(_vm.isModalOpen),callback:function ($$v) {_vm.isModalOpen=$$v},expression:"isModalOpen"}},[_c('div',{staticClass:"modal-body text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.modalImageUrl,"alt":"Image Preview"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }